// export const AUTH_START = "AUTH_START";
// export const AUTH_SUCCESS = "AUTH_SUCCESS";
// export const AUTH_FAIL = "AUTH_FAIL";
export const CURRENT_LANGUAGE = "CURRENT_LANGUAGE";
export const USER_DATA = "USER_DATA";
export const USER_INFO = "USER_INFO";
export const LOGOUT = "LOGOUT";
export const AUTHENTICATED = "AUTHENTICATED";

//Tasks Action Types
export const GET_COMMUNITY_FORM = "GET_COMMUNITY_FORM";
export const GET_EDIT_TASK_FORM = "GET_EDIT_TASK_FORM";
export const GET_TASKS_WITH_PROCEDURES = "GET_TASKS_WITH_PROCEDURES";
export const GET_TASKS_COUNT = "GET_TASKS_COUNT";
export const GET_TASK_DETAILS = "GET_TASK_DETAILS";
export const GET_SUB_TASK_DETAILS = "GET_SUB_TASK_DETAILS";
export const GET_ALL_TASK_ATTACHMENTS = "GET_ALL_TASK_ATTACHMENTS";
export const GET_ALL_SUB_TASK_ATTACHMENTS = "GET_ALL_SUB_TASK_ATTACHMENTS";
export const GET_SUB_TASK_FORM = "GET_SUB_TASK_FORM";
export const SEARCHKEY = "SEARCHKEY";
export const COMMUNITY = "COMMUNITY";

//workteams
export const GET_WORK_TEAMS = "GET_WORK_TEAMS";
//links
export const GET_ALL_LINKS = "GET_ALL_LINKS";
export const ADD_LINK = "ADD_LINK";
export const UPDATE_LINK = "UPDATE_LINK";
export const GET_LINK = "GET_LINK";
export const DELETE_LINK = "DELETE_LINK";
//agenda
export const GET_ALL_AGENDA = "GET_ALL_AGENDA";
export const ADD_AGENDA = "ADD_AGENDA";
export const UPDATE_AGENDA = "UPDATE_AGENDA";
export const GET_AGENDA = "GET_AGENDA";
export const DELETE_AGENDA = "DELETE_AGENDA";
//assignments
export const GET_ALL_ASSIGNMENTS = "GET_ALL_ASSIGNMENTS";
export const ADD_ASSIGNMENT = "ADD_ASSIGNMENT";
export const UPDATE_ASSIGNMENT = "UPDATE_ASSIGNMENT";
export const GET_ASSIGNMENT = "GET_ASSIGNMENT";
export const DELETE_ASSIGNMENT = "DELETE_ASSIGNMENT";
export const GET_ALL_COMMENTS = "GET_ALL_COMMENTS";
export const ADD_COMMENT = "ADD_COMMENT";
//sub Assignments
export const GET_ALL_SUB_ASSIGNMENTS = "GET_ALL_SUB_ASSIGNMENTS";
export const ADD_SUB_ASSIGNMENT = "ADD_SUB_ASSIGNMENT";
export const UPDATE_SUB_ASSIGNMENT = "UPDATE_SUB_ASSIGNMENT";
export const GET_SUB_ASSIGNMENT = "GET_SUB_ASSIGNMENT";
export const DELETE_SUB_ASSIGNMENT = "DELETE_SUB_ASSIGNMENT";
export const GET_ALL_SUB_COMMENTS = "GET_ALL_SUB_COMMENTS";
export const ADD_SUB_COMMENT = "ADD_SUB_COMMENT";
//Projects
export const PROJECTSEARCHKEY = "PROJECTSEARCHKEY";

//Projects
export const FILESSEARCHKEY = "FILESSEARCHKEY";

//Reload
export const RELOAD = "RELOAD";

// messenger
export const ROOM = "ROOM";
